export const PAYMENT_TYPES = {
	CREDIT_CARD: 'paymentech',
	PAYPAL: 'paypal'
};

export const SUBSCRIPTION_TYPES = {
	NEW_SUBSCRIPTION: 'firstTimeSubscription',
	// covers both reactivation and buying additional products.
	EXISTING_SUBSCRIPTION: 'existingSubscription'
};

export const TRANSACTION_TYPE = {
	PREPROCESS: 'preprocess',
	PROCESS: 'process'
};

export const SUBSCRIPTION_ACTION_SOURCE = {
	IN_APP: 'in_app',
	CUSTOMER_SUPPORT: 'customer_support',
	THIRD_PARTY: 'third_party',
	SOURCE_UNKNOWN: 'source_unknown',
	IN_APP_LEGACY: 'in_app_legacy',
	PARENT_SECTION: 'parent_section',
	REGPATH: 'regpath',
	EMAIL_SPECIAL_OFFER_UPGRADE: 'email_special_offer_upgrade'
};

export const SUBSCRIPTION_RENEWAL_TERM = {
	day: 'Day',
	month: 'Month',
	year: 'Year'
};

export const SUBSCRIPTION_STATUS = {
	ACTIVE: 'active',
	CANCELLED: 'opt_out',
	TERMINATED: 'terminated'
};
const SUBSCRIPTION_PAUSE_PREFIX = 'abc-parent-section-cancel-premium-subscription:';

export const SUBSCRIPTION_PAUSE_TRACKING_IDS = Object.freeze({
	PAUSE_MEMBERSHIP: `${SUBSCRIPTION_PAUSE_PREFIX}pause`,
	PAUSE_MEMBERSHIP_PARENT_SECTION: `${SUBSCRIPTION_PAUSE_PREFIX}pause-membership`,
	PAUSE_MEMBERSHIP_TERM: `${SUBSCRIPTION_PAUSE_PREFIX}`,
	PAUSE_COSTUMER_SUPPORT: `${SUBSCRIPTION_PAUSE_PREFIX}customer-support`,
	PAUSE_MEMBERSHIP_MANAGE: `${SUBSCRIPTION_PAUSE_PREFIX}manage-my-pause`,
	PAUSE_CONTACT_SUPPORT: `${SUBSCRIPTION_PAUSE_PREFIX}contact-support`,
	PAUSE_RESUME_MEMBERSHIP: `${SUBSCRIPTION_PAUSE_PREFIX}resume-membership`,
	PAUSE_STAY_PAUSED: `${SUBSCRIPTION_PAUSE_PREFIX}stay-paused`,
	PAUSE_ERROR: `${SUBSCRIPTION_PAUSE_PREFIX}error`
});
